import { useNavigate } from "react-router-dom";
import { User, ShieldCheck, Building2, LogOut, LayoutDashboard, Briefcase } from "lucide-react";
import { DropdownMenu, DropdownMenuTrigger, DropdownMenuContent, DropdownMenuItem, DropdownMenuLabel, DropdownMenuSeparator } from "./ui/dropdown-menu";
import { useLang } from "../lib/i18n";
import { useAuth } from "../lib/auth";
import { UserAvatar, roleLabel } from "./UserAvatar";

export function ProfileMenu() {
  const { t } = useLang();
  const { user, logout } = useAuth();
  const nav = useNavigate();
  const items = [
    ["profile", User, t("My Profile", "Mi perfil"), "/profile"],
    ["security", ShieldCheck, t("Security", "Seguridad"), "/profile?tab=security"],
    ["company", Briefcase, t("My Company", "Mi empresa"), "/profile?tab=company"],
  ];
  const platform = [
    ["companies", Building2, t("Companies", "Empresas"), "/companies"],
    ["platform", LayoutDashboard, t("Platform Administration", "Administración de la plataforma"), "/platform"],
  ];
  const Item = ([id, Icon, label, to]) => (
    <DropdownMenuItem key={id} onSelect={() => nav(to)} className="min-h-[44px] gap-3 cursor-pointer" data-testid={`profile-menu-${id}`}>
      <Icon className="w-4 h-4" /> {label}
    </DropdownMenuItem>
  );
  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <button className="rounded-full p-0.5 hover:ring-2 hover:ring-[#D9531E]/40 transition-shadow" data-testid="profile-menu-btn" aria-label={t("Account menu", "Menú de cuenta")}>
          <UserAvatar user={user} testid="topbar-avatar" />
        </button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="w-64" data-testid="profile-menu">
        <DropdownMenuLabel className="font-normal">
          <div className="font-bold truncate" data-testid="profile-menu-name">{user.name}</div>
          <div className="text-xs text-slate-500 truncate">{user.email}</div>
          <div className="text-xs font-semibold text-[#D9531E] mt-0.5" data-testid="profile-menu-role">
            {user.platform_admin ? "Platform Super Admin" : roleLabel(t, user.role)}
          </div>
        </DropdownMenuLabel>
        <DropdownMenuSeparator />
        {items.map(Item)}
        {user.platform_admin && <><DropdownMenuSeparator />{platform.map(Item)}</>}
        <DropdownMenuSeparator />
        <DropdownMenuItem onSelect={logout} className="min-h-[44px] gap-3 cursor-pointer text-red-700" data-testid="profile-menu-signout">
          <LogOut className="w-4 h-4" /> {t("Sign Out", "Cerrar sesión")}
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
